// /src/services/storage.js
const S = {
    session: "dhm.session",
    user: "dhm.user",
    membership: "dhm.membership",
};

export function saveSession(v) {
    try { localStorage.setItem(S.session, JSON.stringify(v || {})); } catch { }
}
export function getSessionRaw() {
    try { const s = localStorage.getItem(S.session); return s ? JSON.parse(s) : null; } catch { return null; }
}
export function clearSession() { try { localStorage.removeItem(S.session); } catch { } }

export function saveUser(v) {
    try { localStorage.setItem(S.user, JSON.stringify(v || {})); } catch { }
}
export function getUserRaw() {
    try { const s = localStorage.getItem(S.user); return s ? JSON.parse(s) : null; } catch { return null; }
}
export function clearUser() { try { localStorage.removeItem(S.user); } catch { } }

export function saveMembership(v) {
    try { localStorage.setItem(S.membership, JSON.stringify(v || {})); } catch { }
}
export function getMembershipRaw() {
    try { const s = localStorage.getItem(S.membership); return s ? JSON.parse(s) : null; } catch { return null; }
}
export function clearMembership() { try { localStorage.removeItem(S.membership); } catch { } }

export function clearAll() {
    clearSession(); clearUser(); clearMembership();
}

export const STORAGE_KEYS = S;
